(function () {
  'use strict';

  var CT_SPLIT = '\u005bt4splitlz\u005d';
  var SORT_LABELS = {
    manual: 'Featured',
    relevance: 'Most relevant',
    'best-selling': 'Best selling',
    'price-ascending': 'Price\u2b06\ufe0f',
    'price-descending': 'Price\u2b07\ufe0f'
  };

  function getLabel(sortBy) {
    return SORT_LABELS[sortBy] || sortBy;
  }

  function getRoutesRoot() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }
    return '/';
  }

  function isMobileSortView() {
    return window.matchMedia('(max-width:767px)').matches;
  }

  function isSortUiTarget(el) {
    if (!el || !el.closest) return false;
    return !!el.closest('[data-category-tabs-sort]');
  }

  function closeAllSortPanels(exceptWrap) {
    document.querySelectorAll('[data-category-tabs-sort].is--sort-open').forEach(function (wrap) {
      if (exceptWrap && wrap === exceptWrap) return;
      closeSortPanel(wrap);
    });
  }

  function openSortPanel(sortWrap) {
    if (!sortWrap) return;
    closeAllSortPanels(sortWrap);
    var panel = sortWrap.querySelector('[data-ct-sort-panel]');
    var backdrop = sortWrap.querySelector('[data-ct-sort-backdrop]');
    var toggle = sortWrap.querySelector('[data-ct-sort-toggle]');
    var sortHost = sortWrap.closest('.category-tabs-toolbar__sort');
    if (panel) {
      panel.hidden = false;
      panel.classList.add('is--open');
    }
    if (backdrop) {
      backdrop.hidden = false;
      backdrop.style.pointerEvents = '';
    }
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
    sortWrap.classList.add('is--sort-open');
    if (sortHost) sortHost.classList.add('is--sort-host-open');
    if (isMobileSortView()) document.documentElement.classList.add('category-tabs-sort-open');
  }

  function closeSortPanel(sortWrap) {
    if (!sortWrap) return;
    var panel = sortWrap.querySelector('[data-ct-sort-panel]');
    var backdrop = sortWrap.querySelector('[data-ct-sort-backdrop]');
    var toggle = sortWrap.querySelector('[data-ct-sort-toggle]');
    var sortHost = sortWrap.closest('.category-tabs-toolbar__sort');
    if (panel) {
      panel.classList.remove('is--open');
      panel.hidden = true;
    }
    if (backdrop) {
      backdrop.hidden = true;
      backdrop.style.pointerEvents = 'none';
    }
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
    sortWrap.classList.remove('is--sort-open');
    if (sortHost) sortHost.classList.remove('is--sort-host-open');
    if (!document.querySelector('[data-category-tabs-sort].is--sort-open')) {
      document.documentElement.classList.remove('category-tabs-sort-open');
    }
    armClickShield();
  }

  function resetAllSortOverlays() {
    document.querySelectorAll('[data-category-tabs-sort]').forEach(function (sortWrap) {
      closeSortPanel(sortWrap);
    });
    document.documentElement.classList.remove('category-tabs-sort-open');
    document.documentElement.classList.remove('category-tabs-sort-shield');
    document.querySelectorAll('[data-ct-sort-backdrop]').forEach(function (backdrop) {
      backdrop.hidden = true;
      backdrop.style.pointerEvents = 'none';
    });
    document.querySelectorAll('[data-ct-sort-panel]').forEach(function (panel) {
      panel.hidden = true;
      panel.classList.remove('is--open');
    });
    blockClickUntil = 0;
  }

  function updateSortUI(sortWrap, sortBy, sortBtn) {
    if (!sortWrap || !sortBy) return;
    var label = (sortBtn && sortBtn.textContent.trim()) || getLabel(sortBy);
    sortWrap.setAttribute('data-current-sort', sortBy);
    sortWrap.querySelectorAll('[data-category-tabs-sort-label]').forEach(function (el) {
      el.textContent = label;
    });
    sortWrap.querySelectorAll('[data-category-tabs-sort-item]').forEach(function (btn) {
      var selected = btn.getAttribute('data-value') === sortBy;
      btn.classList.toggle('is--selected', selected);
      btn.setAttribute('aria-selected', selected ? 'true' : 'false');
    });
  }

  function getActivePanel(sortWrap) {
    var panel = sortWrap && sortWrap.closest('[data-category-panel]');
    if (panel && panel.classList.contains('is-active')) return panel;
    return document.querySelector('.category-tabs-panel.is-active');
  }

  function getActiveTab(panel) {
    if (!panel) return null;
    return panel.querySelector('.t4s-tab-content2.t4s-active')
      || panel.querySelector('.t4s-tab-content2:not(.lazyloadt4s)')
      || panel.querySelector('.t4s-tab-content2');
  }

  function getCollectionHandle(tab) {
    if (!tab) return '';
    var handle = tab.getAttribute('data-collection-handle') || '';
    if (handle) return handle;
    var wrap = tab.querySelector('.tabs-content-wrap[data-not-main]');
    if (wrap) handle = wrap.getAttribute('data-ct-collection-handle') || '';
    if (handle) return handle;
    var link = tab.querySelector('[data-collection-url]');
    if (link) {
      var url = link.getAttribute('data-collection-url') || '';
      var parts = url.split('/collections/');
      if (parts[1]) return parts[1].replace(/\/$/, '').split('?')[0];
    }
    return '';
  }

  function getProductsTarget(tab) {
    var wrap = tab && tab.querySelector('.tabs-content-wrap[data-not-main]');
    if (!wrap) return null;
    return wrap.querySelector('[data-contentlm-replace]') || wrap.querySelector('.t4s-products');
  }

  function getProductNodes(target) {
    if (!target) return [];
    var nodes = [];
    try {
      nodes = Array.prototype.slice.call(target.querySelectorAll(':scope > .t4s-product'));
    } catch (err) {}
    if (nodes.length) return nodes;
    return Array.prototype.slice.call(target.querySelectorAll('.t4s-product'));
  }

  function getProductMeta(node) {
    if (!node) return null;
    var el = node.matches && node.matches('[data-product-options]') ? node : node.querySelector('[data-product-options]');
    if (!el) return null;
    try {
      var opts = JSON.parse(el.getAttribute('data-product-options') || '{}');
      var titleEl = node.querySelector('.t4s-product-title');
      var title = titleEl ? titleEl.textContent.replace(/\s+/g, ' ').trim() : (opts.handle || '');
      return { node: node, handle: opts.handle || '', title: title, price: Number(opts.price) || 0 };
    } catch (err) {
      return null;
    }
  }

  function reorderNodes(target, nodes) {
    if (!target || !nodes || !nodes.length) return false;
    var frag = document.createDocumentFragment();
    nodes.forEach(function (node) { frag.appendChild(node); });
    target.innerHTML = '';
    target.appendChild(frag);
    return true;
  }

  function clientSortProducts(tab, sortBy) {
    var target = getProductsTarget(tab);
    var nodes = getProductNodes(target);
    if (!target || !nodes.length) return false;
    var items = nodes.map(getProductMeta).filter(Boolean);
    if (!items.length) return false;
    if (sortBy === 'price-ascending') {
      items.sort(function (a, b) { return a.price - b.price || a.title.localeCompare(b.title); });
    } else if (sortBy === 'price-descending') {
      items.sort(function (a, b) { return b.price - a.price || a.title.localeCompare(b.title); });
    } else {
      return false;
    }
    return reorderNodes(target, items.map(function (item) { return item.node; }));
  }

  function getHandlesFromHtml(html) {
    try {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var products = doc.querySelector('.t4s-main-collection-page [data-contentlm-replace]')
        || doc.querySelector('[data-contentlm-replace].t4s-products')
        || doc.querySelector('.tabs-content-wrap [data-contentlm-replace]')
        || doc.querySelector('[data-contentlm-replace]');
      var scope = products || doc;
      var handles = [];
      scope.querySelectorAll('[data-product-options]').forEach(function (el) {
        try {
          var h = JSON.parse(el.getAttribute('data-product-options') || '{}').handle;
          if (h) handles.push(h);
        } catch (err) {}
      });
      return handles;
    } catch (err) {
      return [];
    }
  }

  function getCurrentHandles(tab) {
    return getProductNodes(getProductsTarget(tab)).map(function (node) {
      var meta = getProductMeta(node);
      return meta && meta.handle ? meta.handle : '';
    }).filter(Boolean);
  }

  function updateSortMeta(tab, sortBy, handle, persist) {
    if (!tab) return;
    tab.classList.remove('lazyloadt4s');
    tab.classList.add('lazyloadt4sed');
    tab.setAttribute('data-loaded-sort', sortBy);
    if (handle) tab.setAttribute('data-collection-handle', handle);
    var wrap = tab.querySelector('.tabs-content-wrap[data-not-main]');
    if (wrap) {
      wrap.setAttribute('data-ct-sort', sortBy);
      if (handle) wrap.setAttribute('data-ct-collection-handle', handle);
      restoreWrapPersist(wrap, persist);
    }
  }

  function fetchSortedHandles(handle, sortBy, needCount) {
    var routesRoot = getRoutesRoot();
    var all = [];
    var seen = {};
    var maxPages = 15;
    function pageUrl(page) {
      var url = routesRoot + 'collections/' + encodeURIComponent(handle) + '/?sort_by=' + encodeURIComponent(sortBy);
      if (page > 1) url += '&page=' + encodeURIComponent(page);
      return url;
    }
    function next(page) {
      if (page > maxPages) return Promise.resolve(all);
      return fetch(pageUrl(page), { credentials: 'same-origin', cache: 'no-store' })
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var handles = getHandlesFromHtml(html);
          var added = 0;
          handles.forEach(function (h) {
            if (!seen[h]) {
              seen[h] = true;
              all.push(h);
              added++;
            }
          });
          if (!handles.length || !added) return all;
          if (needCount && all.length >= needCount) return all;
          return next(page + 1);
        })
        .catch(function () { return all; });
    }
    return next(1);
  }

  function reorderByHandles(tab, handles) {
    if (!handles || !handles.length) return false;
    var target = getProductsTarget(tab);
    var nodes = getProductNodes(target);
    if (!target || !nodes.length) return false;
    var map = {};
    nodes.forEach(function (node) {
      var meta = getProductMeta(node);
      if (meta && meta.handle && !map[meta.handle]) map[meta.handle] = node;
    });
    var ordered = [];
    handles.forEach(function (h) { if (map[h]) ordered.push(map[h]); });
    nodes.forEach(function (node) {
      var meta = getProductMeta(node);
      if (meta && meta.handle && ordered.indexOf(node) === -1) ordered.push(node);
    });
    if (!ordered.length) return false;
    return reorderNodes(target, ordered);
  }

  function parseFragment(html) {
    if (!html) return '';
    var start = html.indexOf(CT_SPLIT);
    if (start !== -1) {
      var end = html.indexOf(CT_SPLIT, start + CT_SPLIT.length);
      if (end !== -1) {
        var frag = html.slice(start + CT_SPLIT.length, end);
        if (frag.indexOf('tabs-content-wrap') !== -1) return frag;
      }
    }
    try {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var wrap = doc.querySelector('.tabs-content-wrap[data-not-main], .tabs-content-wrap');
      return wrap ? wrap.outerHTML : '';
    } catch (err) {}
    return '';
  }

  function extractProductsInner(html) {
    try {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var products = doc.querySelector('[data-contentlm-replace]')
        || doc.querySelector('.t4s-main-collection-page [data-contentlm-replace]')
        || doc.querySelector('.t4s-products');
      if (products && products.innerHTML) return products.innerHTML;
    } catch (err) {}
    return '';
  }

  function readWrapPersist(tab) {
    var wrap = tab && tab.querySelector('.tabs-content-wrap[data-not-main]');
    if (!wrap) return null;
    return {
      manualHandles: wrap.getAttribute('data-ct-manual-handles'),
      allowedHandles: wrap.getAttribute('data-ct-allowed-handles'),
      collectionCount: wrap.getAttribute('data-ct-collection-count')
    };
  }

  function restoreWrapPersist(wrap, persist) {
    if (!wrap || !persist) return;
    if (persist.manualHandles) wrap.setAttribute('data-ct-manual-handles', persist.manualHandles);
    if (persist.allowedHandles) wrap.setAttribute('data-ct-allowed-handles', persist.allowedHandles);
    if (persist.collectionCount) wrap.setAttribute('data-ct-collection-count', persist.collectionCount);
  }

  function getManualHandles(tab) {
    var wrap = tab && tab.querySelector('.tabs-content-wrap[data-not-main]');
    if (!wrap) return [];
    var raw = wrap.getAttribute('data-ct-manual-handles');
    if (raw) {
      try {
        var parsed = JSON.parse(raw);
        if (Array.isArray(parsed) && parsed.length) return parsed;
      } catch (err) {}
    }
    var handles = getProductNodes(getProductsTarget(tab)).map(function (node) {
      var meta = getProductMeta(node);
      return meta && meta.handle ? meta.handle : '';
    }).filter(Boolean);
    if (handles.length) wrap.setAttribute('data-ct-manual-handles', JSON.stringify(handles));
    return handles;
  }

  function buildTabSearchUrl(handle, sortBy, sectionId) {
    var routesRoot = getRoutesRoot();
    return routesRoot + 'search?q=' + encodeURIComponent(handle + '_ch') + '+cttag&section_id=' + encodeURIComponent(sectionId) + '&sort_by=' + encodeURIComponent(sortBy);
  }

  function fetchSortOrderHandles(tab, handle, sortBy, sectionId, needCount) {
    if (sortBy === 'manual') return Promise.resolve(getManualHandles(tab));
    if (sortBy === 'relevance') {
      return fetch(buildTabSearchUrl(handle, sortBy, sectionId), { credentials: 'same-origin', cache: 'no-store' })
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var searchHandles = getHandlesFromHtml(html);
          return searchHandles.length ? searchHandles : fetchSortedHandles(handle, sortBy, needCount);
        });
    }
    return fetchSortedHandles(handle, sortBy, needCount);
  }

  function applyFragmentToTab(tab, fragment, sortBy, handle, persist) {
    if (!tab || !fragment || fragment.indexOf('tabs-content-wrap') === -1) return false;
    tab.innerHTML = fragment;
    tab.classList.remove('lazyloadt4s');
    tab.classList.add('lazyloadt4sed');
    tab.setAttribute('data-loaded-sort', sortBy);
    if (handle) tab.setAttribute('data-collection-handle', handle);
    var wrap = tab.querySelector('.tabs-content-wrap[data-not-main]');
    if (wrap) {
      wrap.setAttribute('data-ct-sort', sortBy);
      if (handle) wrap.setAttribute('data-ct-collection-handle', handle);
      restoreWrapPersist(wrap, persist);
    }
    return true;
  }

  function applyProductsInner(tab, inner, sortBy, handle, persist) {
    var target = getProductsTarget(tab);
    if (!target || !inner) return false;
    target.innerHTML = inner;
    tab.classList.remove('lazyloadt4s');
    tab.classList.add('lazyloadt4sed');
    tab.setAttribute('data-loaded-sort', sortBy);
    if (handle) tab.setAttribute('data-collection-handle', handle);
    var wrap = tab.querySelector('.tabs-content-wrap[data-not-main]');
    if (wrap) {
      wrap.setAttribute('data-ct-sort', sortBy);
      if (handle) wrap.setAttribute('data-ct-collection-handle', handle);
      restoreWrapPersist(wrap, persist);
    }
    return true;
  }

  function notifySorted(tab, handle, sortBy, sectionId) {
    document.dispatchEvent(new CustomEvent('category-tabs:sorted', {
      bubbles: true,
      detail: { tab: tab, handle: handle, sortBy: sortBy, sectionId: sectionId }
    }));
  }

  function reloadTabSort(tab, handle, sortBy, sectionId) {
    if (!tab || !handle || !sortBy) return Promise.resolve(false);
    var persist = readWrapPersist(tab);
    var handlesBefore = getCurrentHandles(tab);
    var hasProducts = handlesBefore.length > 0;
    var needCount = handlesBefore.length;
    if (persist && persist.collectionCount) {
      var total = parseInt(persist.collectionCount, 10);
      if (!isNaN(total) && total > needCount) needCount = total;
    }
    tab.classList.add('is--loading-sort');
    return fetchSortOrderHandles(tab, handle, sortBy, sectionId, needCount).then(function (orderHandles) {
      var applied = false;

      if (hasProducts) {
        if (orderHandles.length) applied = reorderByHandles(tab, orderHandles);
        if (!applied) applied = clientSortProducts(tab, sortBy);
        if (applied || orderHandles.length) {
          updateSortMeta(tab, sortBy, handle, persist);
          notifySorted(tab, handle, sortBy, sectionId);
          return true;
        }
        return false;
      }

      return fetch(buildTabSearchUrl(handle, sortBy, sectionId), { credentials: 'same-origin', cache: 'no-store' })
        .then(function (res) { return res.text(); })
        .then(function (html) {
          applied = applyFragmentToTab(tab, parseFragment(html), sortBy, handle, persist);
          if (!applied) applied = applyProductsInner(tab, extractProductsInner(html), sortBy, handle, persist);
          if (!applied && orderHandles.length) applied = reorderByHandles(tab, orderHandles);
          if (!applied) applied = clientSortProducts(tab, sortBy);
          if (applied) {
            updateSortMeta(tab, sortBy, handle, persist);
            notifySorted(tab, handle, sortBy, sectionId);
          }
          return applied;
        });
    }).catch(function () {
      if (!hasProducts) return false;
      var applied = clientSortProducts(tab, sortBy);
      if (applied) {
        updateSortMeta(tab, sortBy, handle, persist);
        notifySorted(tab, handle, sortBy, sectionId);
      }
      return applied;
    }).finally(function () {
      tab.classList.remove('is--loading-sort');
    });
  }

  var sortLock = false;
  var blockClickUntil = 0;

  function armClickShield() {
    blockClickUntil = Date.now() + 400;
    document.documentElement.classList.add('category-tabs-sort-shield');
    setTimeout(function () {
      document.documentElement.classList.remove('category-tabs-sort-shield');
    }, 400);
  }

  function blockGhostClick(e) {
    if (Date.now() >= blockClickUntil) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
  }

  function applySortChange(sortBtn, sortWrap) {
    try {
      if (!sortBtn || sortLock) return false;
      sortWrap = sortWrap || sortBtn.closest('[data-category-tabs-sort]');
      if (!sortWrap) return false;

      var sortBy = sortBtn.getAttribute('data-value');
      if (!sortBy) return false;

      var prev = sortWrap.getAttribute('data-current-sort')
        || sortWrap.getAttribute('data-default-sort')
        || 'manual';

      if (sortBy === prev) {
        closeSortPanel(sortWrap);
        return false;
      }

      sortLock = true;
      setTimeout(function () { sortLock = false; }, 400);

      updateSortUI(sortWrap, sortBy, sortBtn);
      closeSortPanel(sortWrap);

      var sectionId = sortWrap.getAttribute('data-section-id') || '';
      if (!sectionId) {
        var sectionEl = sortWrap.closest('[id^="shopify-section-"]');
        if (sectionEl) sectionId = sectionEl.id.replace('shopify-section-', '');
      }

      var panel = getActivePanel(sortWrap);
      var tab = getActiveTab(panel);
      var handle = getCollectionHandle(tab);

      if (!tab || !handle || !sectionId) return true;

      var wrap = tab.querySelector('.tabs-content-wrap[data-not-main]');
      if (wrap) wrap.setAttribute('data-ct-sort', sortBy);

      if (sortBy === 'price-ascending' || sortBy === 'price-descending') {
        if (clientSortProducts(tab, sortBy)) {
          tab.setAttribute('data-loaded-sort', sortBy);
          notifySorted(tab, handle, sortBy, sectionId);
          return true;
        }
      }

      reloadTabSort(tab, handle, sortBy, sectionId);
      return true;
    } catch (err) {
      sortLock = false;
      return false;
    }
  }

  window.__categoryTabsApplySort = function (sortBtn) {
    return applySortChange(sortBtn, sortBtn && sortBtn.closest('[data-category-tabs-sort]'));
  };

  window.__categoryTabsCloseSort = closeSortPanel;
  window.__categoryTabsResetSortOverlays = resetAllSortOverlays;

  function onSortInteraction(e) {
    if (!e.target || !e.target.closest) return;

    var sortBtn = e.target.closest('[data-category-tabs-sort-item]');
    if (sortBtn) {
      var itemWrap = sortBtn.closest('[data-category-tabs-sort]');
      if (!itemWrap) return;
      if (e.type === 'touchend') e.preventDefault();
      e.stopPropagation();
      applySortChange(sortBtn, itemWrap);
      return;
    }

    var closeBtn = e.target.closest('[data-ct-sort-close]');
    if (closeBtn) {
      var closeWrap = closeBtn.closest('[data-category-tabs-sort]');
      if (closeWrap) {
        if (e.type === 'touchend') e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        closeSortPanel(closeWrap);
      }
      return;
    }

    var backdrop = e.target.closest('[data-ct-sort-backdrop]');
    if (backdrop) {
      var backdropWrap = backdrop.closest('[data-category-tabs-sort]');
      if (backdropWrap) {
        if (e.type === 'touchend') e.preventDefault();
        e.stopPropagation();
        closeSortPanel(backdropWrap);
      }
      return;
    }

    var toggle = e.target.closest('[data-ct-sort-toggle]');
    if (toggle) {
      var sortWrap = toggle.closest('[data-category-tabs-sort]');
      if (!sortWrap) return;
      e.preventDefault();
      e.stopPropagation();
      if (sortWrap.classList.contains('is--sort-open')) closeSortPanel(sortWrap);
      else openSortPanel(sortWrap);
      return;
    }

    if (!isMobileSortView() && !isSortUiTarget(e.target)) {
      closeAllSortPanels();
    }
  }

  document.addEventListener('mousedown', onSortInteraction, true);
  document.addEventListener('touchend', onSortInteraction, { capture: true, passive: false });
  document.addEventListener('click', blockGhostClick, true);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeAllSortPanels();
  });
})();
